export function ensureMinRows<T>(rows: T[] | null | undefined, createEmpty: () => T): T[] {
  const list = rows ?? [];
  return list.length > 0 ? list : [createEmpty()];
}

export function isSingleEmptyRow<T>(rows: T[], isEmpty: (row: T) => boolean): boolean {
  return rows.length === 1 && isEmpty(rows[0]);
}

export function removeRowKeepingMinimum<T>(rows: T[], index: number, createEmpty: () => T): T[] {
  return ensureMinRows(
    rows.filter((_, rowIndex) => rowIndex !== index),
    createEmpty,
  );
}
